import * as $runtime from "../runtime.js";
import * as Control$dBind from "../Control.Bind/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList from "../Data.List/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRational$dSerialized from "../Data.Rational.Serialized/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Data$dUnfoldable1 from "../Data.Unfoldable1/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dPackagingContainer from "../Restaumatic.Menu.V2.Types.PackagingContainer/index.js";
const $Container = _1 => ({tag: "Container", _1});
const Container = value0 => $Container(value0);
const Contained = x => x;
const showContainer = dictShow => ({show: v => dictShow.show(v._1.details) + ": " + Data$dShow.showIntImpl(v._1.capacity._1) + " % " + Data$dShow.showIntImpl(v._1.capacity._2)});
const showContained = dictShow => (
  {
    show: v => Data$dShow.showIntImpl(v.volume._1) + " % " + Data$dShow.showIntImpl(v.volume._2) + " in [" + Data$dFoldable.foldlArray(v$1 => x => {
      if (v$1.init) { return {init: false, acc: x}; }
      return {init: false, acc: v$1.acc + ", " + x};
    })({init: true, acc: ""})(Data$dFunctor.arrayMap(showContainer(dictShow).show)(v.allowedContainers)).acc + "]"
  }
);
const packEachProductToItsFirstAllowedContainer = dictOrd => containeds => Data$dArray.mapMaybe(v => {
  const $0 = Data$dArray.index(v.allowedContainers)(0);
  if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", Data$dTuple.$Tuple($0._1, containeds)); }
  return Data$dMaybe.Nothing;
})(containeds);
const mergePackagingContainersConfig = x => y => (
  {
    volume: (() => {
      const $0 = Data$dRecord.unsafeGet("volume")(x);
      const $1 = Data$dRecord.unsafeGet("volume")(y);
      const v = Data$dRational$dSerialized.ordRational.compare($0)($1);
      if (v.tag === "LT") { return $1; }
      if (v.tag === "EQ") { return $0; }
      if (v.tag === "GT") { return $0; }
      $runtime.fail();
    })(),
    allowedContainers: Data$dList.toUnfoldable(Data$dUnfoldable.unfoldableArray)(Data$dMap$dInternal.keys(Data$dSet.intersection(Data$dOrd.ordString)(Data$dFoldable.foldlArray(m => a => Data$dMap$dInternal.insert(Data$dOrd.ordString)(a)()(m))(Data$dMap$dInternal.Leaf)(Data$dRecord.unsafeGet("allowedContainers")(x)))(Data$dFoldable.foldlArray(m => a => Data$dMap$dInternal.insert(Data$dOrd.ordString)(a)()(m))(Data$dMap$dInternal.Leaf)(Data$dRecord.unsafeGet("allowedContainers")(y)))))
  }
);
const mergeMaybePackagingContainersConfig = v => v1 => {
  if (v.tag === "Nothing") { return v1; }
  if (v1.tag === "Nothing") { return v; }
  if (v.tag === "Just") {
    if (v1.tag === "Just") { return Data$dMaybe.$Maybe("Just", mergePackagingContainersConfig(v._1)(v1._1)); }
    $runtime.fail();
  }
  $runtime.fail();
};
const eqContainer = dictEq => ({eq: v => v1 => dictEq.eq(v._1.details)(v1._1.details)});
const ordContainer = dictOrd => (
  {
    compare: v => v1 => dictOrd.compare(v._1.details)(v1._1.details),
    Eq0: () => {
      const $0 = dictOrd.Eq0();
      return {eq: v => v1 => $0.eq(v._1.details)(v1._1.details)};
    }
  }
);
const eqContained = dictEq => (
  {
    eq: v => v1 => v.volume._1 === v1.volume._1 && v.volume._2 === v1.volume._2 && Data$dEq.eqArrayImpl(v$1 => v1$1 => dictEq.eq(v$1._1.details)(v1$1._1.details))(v.allowedContainers)(v1.allowedContainers)
  }
);
const computePackagingContainers = categories => packagingContainers => productsCatalogue => modifiersCatalogue => algo => {
  const contained = containedId => v => (
    {
      allowedContainers: Data$dArray.mapMaybe(containerId => {
        const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(containerId)(packagingContainers);
        if ($0.tag === "Just") {
          if ($0._1.enabled) { return Data$dMaybe.$Maybe("Just", $Container({details: containerId, capacity: $0._1.capacity, price: $0._1.price})); }
          return Data$dMaybe.Nothing;
        }
        if ($0.tag === "Nothing") { return Data$dMaybe.Nothing; }
        $runtime.fail();
      })(v.allowedContainers),
      volume: v.volume,
      containedId
    }
  );
  const $0 = algo(Data$dOrd.ordString);
  return x => {
    const $1 = $0(Control$dBind.arrayBind(x)(v => Data$dSemigroup.concatArray((() => {
      const $1 = contained(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.$ContainedId("ProductId", v.products));
      const $2 = Data$dFoldable.foldrArray(mergeMaybePackagingContainersConfig)(Data$dMaybe.Nothing)(Data$dFunctor.arrayMap(id => {
        const $2 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(id)(productsCatalogue);
        if ($2.tag === "Just") {
          if ($2._1.packagingContainersConfigOverride.tag === "Just") { return Data$dMaybe.$Maybe("Just", $2._1.packagingContainersConfigOverride._1); }
          if ($2._1.packagingContainersConfigOverride.tag === "Nothing") {
            const $3 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)($2._1.category)(categories);
            if ($3.tag === "Just") { return Data$dRecord.unsafeGet("packagingContainersConfig")($3._1); }
            if ($3.tag === "Nothing") { return Data$dMaybe.Nothing; }
            $runtime.fail();
          }
          $runtime.fail();
        }
        if ($2.tag === "Nothing") { return Data$dMaybe.Nothing; }
        $runtime.fail();
      })(v.products));
      if ($2.tag === "Nothing") { return []; }
      if ($2.tag === "Just") { return Data$dUnfoldable1.replicate1(Data$dUnfoldable1.unfoldable1Array)(1)($1($2._1)); }
      $runtime.fail();
    })())(Data$dArray.mapMaybe(v1 => {
      const $1 = Data$dMap$dInternal.lookup(Data$dOrd.ordString)(v1.modifier)(modifiersCatalogue);
      const $2 = (() => {
        if ($1.tag === "Just") {
          return Data$dArray.index(Data$dArray.mapMaybe(v5 => Data$dMap$dInternal.lookup(Data$dOrd.ordString)(v1.modifierItem)(v5.items._1))($1._1.sections))(0);
        }
        if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
        $runtime.fail();
      })();
      const $3 = (() => {
        if ($2.tag === "Just") { return $2._1.packagingContainersConfig; }
        if ($2.tag === "Nothing") { return Data$dMaybe.Nothing; }
        $runtime.fail();
      })();
      const $4 = contained(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.$ContainedId("ModifierItemId", v1.modifier, v1.modifierItem));
      if ($3.tag === "Just") { return Data$dMaybe.$Maybe("Just", $4($3._1)); }
      return Data$dMaybe.Nothing;
    })(v.modifiers))));
    return Data$dTuple.$Tuple(
      Data$dFunctor.arrayMap(v => Data$dTuple.$Tuple(v._1._1.details, v._2))($1),
      Data$dFoldable.foldlArray(Data$dMoney$dRounded.additiveMoney.add)(0)(Data$dFunctor.arrayMap(x$1 => x$1._1._1.price)($1))
    );
  };
};
export {
  $Container,
  Contained,
  Container,
  computePackagingContainers,
  eqContained,
  eqContainer,
  mergeMaybePackagingContainersConfig,
  mergePackagingContainersConfig,
  ordContainer,
  packEachProductToItsFirstAllowedContainer,
  showContained,
  showContainer
};
